const EU_VAT_PREFIX_BY_COUNTRY: Record<string, string> = {
  AT: 'AT',
  BE: 'BE',
  BG: 'BG',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  EE: 'EE',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  GR: 'EL',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IT: 'IT',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  MT: 'MT',
  NL: 'NL',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SI: 'SI',
  SK: 'SK',
  XI: 'XI',
};

const EU_VAT_ID_PATTERNS: Partial<Record<string, RegExp>> = {
  AT: /^ATU\d{8}$/,
  BE: /^BE[01]\d{9}$/,
  BG: /^BG\d{9,10}$/,
  CY: /^CY\d{8}[A-Z]$/,
  CZ: /^CZ\d{8,10}$/,
  DE: /^DE\d{9}$/,
  DK: /^DK\d{8}$/,
  EE: /^EE\d{9}$/,
  EL: /^EL\d{9}$/,
  ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,
  FI: /^FI\d{8}$/,
  FR: /^FR[A-Z0-9]{2}\d{9}$/,
  HR: /^HR\d{11}$/,
  HU: /^HU\d{8}$/,
  IE: /^IE(\d{7}[A-Z]{1,2}|\d[A-Z0-9]\d{5}[A-Z])$/,
  IT: /^IT\d{11}$/,
  LT: /^LT(\d{9}|\d{12})$/,
  LU: /^LU\d{8}$/,
  LV: /^LV\d{11}$/,
  MT: /^MT\d{8}$/,
  NL: /^NL\d{9}B\d{2}$/,
  PL: /^PL\d{10}$/,
  PT: /^PT\d{9}$/,
  RO: /^RO\d{2,10}$/,
  SE: /^SE\d{12}$/,
  SI: /^SI\d{8}$/,
  SK: /^SK\d{10}$/,
  XI: /^XI(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/,
};

const EU_VAT_ID_EXAMPLES: Record<string, string> = {
  AT: 'ATU12345678',
  DE: 'DE123456789',
  EL: 'EL123456789',
};
const DEFAULT_EU_VAT_ID_EXAMPLE = 'DE123456789';

export const normalizeEuVatId = (vatId: string): string => {
  return vatId.replace(/[\s._-]+/g, '').toUpperCase();
};

export const getEuVatPrefixForCountry = (countryIsoCode?: string | null): string | null => {
  if (!countryIsoCode) return null;
  return EU_VAT_PREFIX_BY_COUNTRY[countryIsoCode.toUpperCase()] ?? null;
};

export const getEuVatIdExample = (countryIsoCode?: string | null): string => {
  const prefix = getEuVatPrefixForCountry(countryIsoCode);
  if (!prefix) return DEFAULT_EU_VAT_ID_EXAMPLE;
  return EU_VAT_ID_EXAMPLES[prefix] ?? `${prefix}123456789`;
};

export const isEuVatIdFormatValid = (vatId: string, countryIsoCode?: string | null): boolean => {
  const normalizedVatId = normalizeEuVatId(vatId);
  if (!normalizedVatId) return true;

  const expectedPrefix = getEuVatPrefixForCountry(countryIsoCode);
  if (expectedPrefix && !normalizedVatId.startsWith(expectedPrefix)) return false;

  const prefix = expectedPrefix ?? normalizedVatId.slice(0, 2);
  return EU_VAT_ID_PATTERNS[prefix]?.test(normalizedVatId) ?? false;
};
